import React from 'react';
import { getEmbedCode } from '../../helper/sharing';

const Embed = props => (
  <div className="ifdw-infobox-embed">
    <p className="ifdw-infobox--infotext">
      {props['embed.description']}
    </p>
    <div className="ifdw-infobox--code">
      <code>{`${getEmbedCode()}`}</code>
    </div>
  </div>
);

export default Embed;



// WEBPACK FOOTER //
// ./src/components/Infobox/embed.js